import { z } from 'zod';

/**
 * 利用企業編集フォームのバリデーションスキーマ
 */
export const editClientSchema = z.object({
  name: z.string().trim().min(1, '会社名を入力してください'),
  contactPersonName: z.string().trim().min(1, '担当者の氏名を入力してください'),
  contactPersonEmail: z
    .string()
    .trim()
    .email({ message: 'メールアドレスの形式が正しくありません' }),
  contactPersonPhone: z
    .string()
    .trim()
    .min(1, '登録電話番号を入力してください')
    .regex(/^[\d-]+$/, '電話番号は数字とハイフンのみ入力してください'),
  corporateNumber: z.string().optional(),
  externalClientId: z.string().optional(),
  groupId: z.string().optional(),
  employeeCount: z.preprocess(
    val => (typeof val === 'string' && val.trim() === '' ? Number.NaN : val),
    z.coerce
      .number('半角数字で入力してください')
      .int('半角数字で入力してください')
      .gte(0, '0以上の整数を入力してください')
  ),
  customFields: z
    .record(z.string(), z.union([z.string(), z.array(z.string())]).optional())
    .optional(),
  /** 有効なフィーチャーフラグのキー配列 */
  clientFeatureFlags: z.array(z.string()).optional(),
});

/**
 * 利用企業編集フォームのフィールド値の型
 */
export type EditClientFormFieldValues = z.infer<typeof editClientSchema>;
